import { EmptyState } from 'ui/emptyState';
import { NoResult } from 'ui/illustrations';
import { EmptyStateWrapper } from '../../AudienceSelection.styled';
import { NoListEmptyStateSubtitle } from './NoListsEmptyStateSubtitle';

export const NO_LISTS_TITLE = 'No lists yet';

export const NoListsEmptyState = () => (
  <EmptyStateWrapper data-test="campaign-editor-no-lists-empty-state">
    <EmptyState
      Illustration={NoResult}
      title={NO_LISTS_TITLE}
      subtitle={<NoListEmptyStateSubtitle />}
    />
  </EmptyStateWrapper>
);
